module.exports = __webpack_public_path__ + "img/تراکت-یک-رو.b685e0b2.png";